import React from "react";

const statusStyles = {
  Active: "bg-blue-50 text-blue-700 border-blue-200",
  Planned: "bg-sky-50 text-sky-700 border-sky-200",
  "On Hold": "bg-amber-50 text-amber-700 border-amber-200",
  Completed: "bg-green-50 text-green-700 border-green-200",
  "In Progress": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "At Risk": "bg-red-50 text-red-700 border-red-200",
};

function StatusBadge({ status }) {
  const style = statusStyles[status] || "bg-gray-100 text-gray-700 border-gray-200";

  return (
    <span className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${style}`}>
      {status}
    </span>
  );
}

export default StatusBadge;
